export default {
  data () {
    return {
      NUMBER: 'number',
      DATE: 'date',
      LIST: 'list',
      FORMAT: 'format',
      FROM: 'from',
      TO: 'to',
      SAVE: 'save',
      UPDATE_CLOSE: 'updateAndClose',
      SHOW: 'show',
      HIDE: 'hide',
      // COMMON
      VALUE: 'value',
      STATUS: 'status',
      ADJUSTMENTORDER: 'adjustment',
      COMPLETED: 'completed',
      COUNTED: 'counted',
      COMPLETED_AND_ADJUSTED: 'completed_and_adjusted',
      // SUPPORTING LIST MODULE
      USERROLES: 'userroles',
      GROUPS: 'groups',
      PRODUCT_TYPES: 'producttypes',
      PRODUCT_GROUPS: 'productgroups',
      USERS: 'users',
      TICKET_STATUS: 'ticketstatuslists',
      PRIORITY: 'priorities',
      TYPE: 'tickettypes',
      CUSTOMER_PRIORITY: 'customerpriorities',
      CUSTOMER_SHIPMENT: 'customershipments',
      CUSTOMER_INDUSTRY: 'customerindustries',
      CONTACTS: 'contacts',
      DELIVERY_ADDRESS: 'deliveryaddress',
      PAYMENTTERMS: 'paymentterms',
      DELIVERYTERMS: 'deliveryterms',
      PRODUCTUNITS: 'productunits',
      WAREHOUSES: 'warehouses',
      // TIMER MODULE
      WORKING: 'working',
      NON_WORKING: 'non_working',
      NOT_DELIVERED: 'not_delivered',
      DELIVERED: 'delivered',
      APPROVED: 'approved',
      NOT_APPROVED: 'not_approved',
      DEVIATION_STATUS: 'deviationstatuses',
      DEVIATION_CATEGORIES: 'deviationcategories',
      DEVIATION_LOCATIONS: 'deviationlocations',
      WAREHOUSE: 'warehouses',
      WAREHOUSELOCATION: 'warehouselocations',
      WH_ORDER: 'warehouseorders',
      ORDERITEMS: 'warehouseorderitems',
      CUSTOMERNETPRICES: 'customernetprices',
      SP_CUSTOMER: 1,
      SP_ORDER: 2,
      SP_PRODUCT: 3,
      SP_SUPPLIER_ORDER: 4,
      SP_DEVIATION: 5,
      /* Ticket Filtes Constants  */
      ALL_TICKETS: 'F_ALL_TICKETS',
      OPEN_TICKETS: 'F_OPEN_TICKETS',
      UNASSIGNED_TICKETS: 'F_UNASSIGNED_TICKETS',
      CLOSED: 'F_CLOSED',
      MY_ACTIVE: 'F_MY_ACTIVE',
      INVOICE_OK: 'ok',
      INVOICE_DRAFT: 'draft',
      INVOICE_COMPLETED: 'completed',
      INVOICE_HAS_NEGATIVE_TOTAL: 'negative_total'
    }
  }
}
